import { useMemo } from 'react'
import { useCurrentUser } from '@axilon-apps/domains-identity/state'
import { isIdentityEnabled } from '@axilon-apps/domains-ontology-ui-state'

/** Display name attributed on Docs Hub revisions written by the current user. */
export function useDocsAuthor(): string {
  const currentUser = useCurrentUser()
  return useMemo(() => {
    const name =
      isIdentityEnabled() && typeof currentUser?.name === 'string' ? currentUser.name : ''
    return name.trim() === '' ? 'unknown' : name.trim()
  }, [currentUser])
}
